import React, { useState, useEffect } from "react";
import {
    Row, Col, Form, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText,
    TabContent, TabPane, Nav, NavItem, NavLink,
    Button
} from 'reactstrap';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import FeeTable from '../Fee/FeeTable';
import AccountComments from './AccountComments';
import {
    getAccount, saveAccount, deleteAccount, getFees, generateLetter, makePayment, deleteFee, addAccountUser, deleteAccountUser, getAccountUser,
} from '../../API';
import { store, getCurrency, toggleOptionsMenu } from '../../Helper';
import Users from '../Users/Users';
import LoadingSVG from '../../icons/Spinner-1s-200px.svg';
import YesNoModal from '../YesNoModal';

function Account(props) {
    const [activeTab, setActiveTab] = useState('fees');
    const [account, setAccount] = useState(null);
    const [isLoadingAccount, setIsLoadingAccount] = useState(true);
    const [fees, setFees] = useState([]);
    const [isLoadingFees, setIsLoadingFees] = useState(true);
    const [deletionConfirmationModal, setDeletionConfirmationModal] = useState(false);

    useEffect(() => {
        fetchAccount();
        fetchFees();
    }, []);

    const fetchAccount = async () => {
        setIsLoadingAccount(true);

        setAccount(await getAccount(props.match.params.accountId));

        setIsLoadingAccount(false);
    };

    const fetchFees = async () => {
        setIsLoadingFees(true);

        setFees(await getFees({ accountIDs: [props.match.params.accountId] }));

        setIsLoadingFees(false);
    };

    const toggleDeletionConfirmationModal = () => setDeletionConfirmationModal(!deletionConfirmationModal);

    const deleteRecord = async () => {
        if (await deleteAccount(account.accountID))
            props.history.push('/admin/accounts');
        else
            console.log('Unable to delete this record.');
    };

    const deleteFeeRecord = async (feeId) => {
        if (await deleteFee(feeId))
            await fetchFees();
        else
            console.log('Unable to delete this record.');
    };

    const addUserConnection = async (userId) => {
        const accountUser = { accountID: account.accountID, userID: userId };
        const existingConnection = await getAccountUser(accountUser.accountID, accountUser.userID);
        if (!existingConnection)
            await addAccountUser(accountUser);
    };

    const deleteUserConnection = async (userId) => {
        await deleteAccountUser(account.accountID, userId);
    };

    const createLetter = async () => {
        const generateLetterResult = await generateLetter(account.accountID);

        var file = window.URL.createObjectURL(generateLetterResult);
        window.open(file, '_blank');
    };

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    let accountJSX = (<div>No Onwer Found...</div>);
    if (isLoadingAccount) {
        accountJSX = (<div className="loading"><img src={LoadingSVG} alt="Loading..." /></div>)
    } else if (account) {
        const contactName = `${account.salutation ? account.salutation + ' ' : ''}${account.contactFirstName} ${account.contactLastName}`;
        const city = `${account.city}, ${account.state} ${account.zip}`;
        const active = account.isActive ? "Active" : "Inactive";
        const activeIcon = account.isActive ? (<i className="fas fa-check-square"></i>) : (<i className="far fa-square" ></i >);

        const editURL = '/admin/accounts/' + account.accountID + '/edit';
        const makePaymentURL = '/admin/makepayment?accountId=' + account.accountID;
        const letterURL = '/admin/letters?accountId=' + account.accountID;

        accountJSX = (
            <div className="item-details">
                <div className="properties">
                    <div className="svg-label tooltip-parent">
                        {activeIcon}
                        <span>{active}</span>
                        <div className="tooltip-target">
                            Active
                        </div>
                    </div>
                    <div className="svg-label tooltip-parent">
                        <i className="fas fa-asterisk"></i>
                        <span>{account.accountNumber}</span>
                        <div className="tooltip-target">
                            Account Number
                        </div>
                    </div>
                    <div className="svg-label tooltip-parent">
                        <i className="fas fa-city"></i>
                        <span>{account.name}</span>
                        <div className="tooltip-target">
                            Account
                        </div>
                    </div>
                    <div className="svg-label tooltip-parent">
                        <i className="fas fa-user"></i>
                        <span>{contactName}</span>
                        <div className="tooltip-target">
                            Contact
                        </div>
                    </div>
                    <div className="svg-label tooltip-parent">
                        <i className="fas fa-map-marker-alt"></i>
                        <span className="full-address">
                            <span>{account.address}</span>
                            <span>{city}</span>
                        </span>
                        <div className="tooltip-target">
                            Address
                        </div>
                    </div>
                    <div className="svg-label tooltip-parent">
                        <i className="fas fa-envelope"></i>
                        <span>{account.emailAddress}</span>
                        <div className="tooltip-target">
                            Email
                        </div>
                    </div>
                    <div className="svg-label tooltip-parent">
                        <i className="fas fa-dollar-sign"></i>
                        <span>{getCurrency(account.currentFeeBalance)}</span>
                        <div className="tooltip-target">
                            Balance
                        </div>
                    </div>
                </div>
                <div className="actions">
                    {window.env.user.userRoles.some(ur => [1, 2].includes(ur.roleID)) ? (
                        <Link to={editURL} className="action-icon action-edit">
                            <i className="fas fa-edit"></i>
                        </Link>
                    ) : null}
                    {window.env.user.userRoles.some(ur => [1, 2, 3, 4].includes(ur.roleID)) ? (
                        <div onClick={toggleOptionsMenu} className="action-icon action-dropdown">
                            <i className="fas fa-ellipsis-h"></i>
                            <div className="action-dropdown-menu">
                                {window.env.user.userRoles.some(ur => [1, 4].includes(ur.roleID)) ? (
                                    <Link className="action-dropdown-menu-item" to={makePaymentURL}><div>Make Payment</div></Link>
                                ) : null}
                                {window.env.user.userRoles.some(ur => [1, 3].includes(ur.roleID)) ? (
                                    <Link className="action-dropdown-menu-item" to={letterURL}><span>Send Letter</span></Link>
                                ) : null}
                                {window.env.user.userRoles.some(ur => [1, 2].includes(ur.roleID)) ? (
                                    <div className="action-dropdown-menu-item" onClick={toggleDeletionConfirmationModal}><span>Delete</span></div>
                                ) : null}
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }

    const feeTableOptions = {
        actions: {
            add: account ? true : false,
            delete: true,
            edit: true,
            view: true,
            viewAccount: false
        },
        accountId: account ? account.accountID : 0
    };

    let feesJSX = (<div>No Fees Found...</div>);
    if (isLoadingFees) {
        feesJSX = (<div className="loading"><img src={LoadingSVG} alt="Loading..." /></div>)
    } else {
        feesJSX = (<FeeTable fees={fees} options={feeTableOptions} deleteRecord={deleteFeeRecord} />);
    }

    return (
        <div id="account">
            <Row className="title-row">
                <Col>
                    <h1>{account ? account.name + ' Account' : 'Account'}</h1>
                </Col>
            </Row>
            <Row className="details-row">
                <Col>
                    {accountJSX}
                </Col>
            </Row>

            <Row className="tabs-row">
                <Col>
                    <Nav tabs>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === 'fees' })}
                                onClick={() => { toggle('fees'); }}>
                                Fees
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === 'comments' })}
                                onClick={() => { toggle('comments'); }}>
                                Comments
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === 'users' })}
                                onClick={() => { toggle('users'); }}>
                                Users
                            </NavLink>
                        </NavItem>
                    </Nav>
                </Col>
            </Row>
            <Row className="tab-content-row">
                <Col>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="fees">
                            {feesJSX}
                        </TabPane>
                        <TabPane tabId="comments">
                            {account ? <AccountComments defaultSearch={{ accountIDs: [account.accountID] }} accountId={account.accountID} /> : null}
                        </TabPane>
                        <TabPane tabId="users">
                            {account ? <Users defaultSearch={{ accountID: account.accountID }} addConnection={addUserConnection} deleteConnection={deleteUserConnection} /> : null}
                        </TabPane>
                    </TabContent>
                </Col>
            </Row>
            <YesNoModal title="Confirm Deletion" yesClick={deleteRecord} open={deletionConfirmationModal} toggle={toggleDeletionConfirmationModal}>Are you sure you want delete this Account?</YesNoModal>
        </div>
    );
}

export default Account;